export const joinGroupConstants = {
  ADD_MEMBER_TO_GROUP_REQUEST: 'JOINGROUP/ADD_MEMBER_TO_GROUP_REQUEST',
  ADD_MEMBER_TO_GROUP_SUCCESS: 'JOINGROUP/ADD_MEMBER_TO_GROUP_SUCCESS',
  ADD_MEMBER_TO_GROUP_FAILURE: 'JOINGROUP/ADD_MEMBER_TO_GROUP_FAILURE'
}
